/*!
 * Copyright 2016, Selerix Systems, Inc. All Rights Reserved
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 */

// extend Bootstrap Modal functions
(function () {
    $.extend($.fn.modal.Constructor.prototype, {
        focus: function () {
            if (this.isShown) {
                var de = this.$element, fe;
                fe = de.find('.modal-focus');
                if (fe.length <= 0) fe = de.find('.btn-main');
                if (fe.length <= 0) fe = de;
                fe.focus();
                return fe;
            }
            return false;
        },
        onShow: function () {
            var de = this.$element,
                dbc = $('#gDefaultButtonID'),
                db = de.find('.btn-main');

            de.data('pd', dbc.val());
            de.data('pf', $(':focus'));

            if (db.length) {                
                if (!db.attr('id')) db.attr('id', 'default_button_' + selerix.globals.guid());
                dbc.val(db.attr('id'));
            }

            var zi = parseInt(de.css('z-index')) + (10 * $('.modal:visible').length);
            de.css('z-index', zi);
            setTimeout(function () {
                $('.modal-backdrop').not('.modal-stack').last().css('z-index', zi - 1).addClass('modal-stack');
            }, 0);
        },
        onShown: function () {
            var dcb = this.$element.data('dcb');

            var body = $('body');
            if ($('.modal.in').length > 0 && !body.hasClass('modal-open')) {
                body.addClass('modal-open');
            }

            this.focus();
            if (typeof dcb === 'function') { dcb(); }
        },
        onHide: function () {
            var de = this.$element;

            $('#gDefaultButtonID').val(de.data('pd'));
            if (de && de.data('pf') && de.data('pf').length > 0) de.data('pf').focus();
            $('#calendar_container').hide();

            de.find('video').each(function () {
                if (this.player) { this.player.pause(); }
            });
        },
        onHidden: function () {
            var de = this.$element;
            if (de.data('temp')) de.remove();
            if ($('body').find('.modal-dialog:visible').length > 0) { $('body').addClass('modal-open'); } // bootstrap 3.3.6 bugfix for stacked modals
        }
    });
})();